<template>
  <component :is="tag" class="rui-icon-text" :class="componentCSS" :title="title">
    <rui-icon :name="icon" />
    <slot>{{ text }}</slot>
  </component>
</template>

<script>
import RuiIcon from '../Icon/Icon.vue'

const variants = [null, 'info', 'success', 'danger', 'warning', 'mute']
const sizes = [null, 'small', 'large']

/**
 * Small wrapper for icon and text with custom styling.
 *
 * @preset Default { "props": { "icon": "doc:map-pin", "text": "You are here" } }
 * @propsGroup Display  [tag, variant, size]
 * @propsGroup Content  [text, icon, title]
 */
export default {
  name: 'RuiIconText',
  components: { RuiIcon },
  props: {
    /** Text. Will be overridden by default slot content */
    text: { required: false, type: [String, Number], default: null },
    /**
     * Color variant
     *
     * @values info, success, danger, warning, mute
     */
    variant: { required: false, type: String, default: null, validator: v => variants.includes(v) },
    /**
     * Size of the whole component
     *
     * @values small, large
     */
    size: { required: false, type: String, default: null, validator: v => sizes.includes(v) },
    /** Icon name */
    icon: { required: false, type: String, default: null },
    /** Icon title, for when a bit of help is needed */
    title: { required: false, type: String, default: null },
    /** Custom wrapping tag */
    tag: { required: false, type: String, default: 'div' },
  },
  computed: {
    componentCSS () {
      return [
        this.size && `rui-icon-text--${this.size}`,
        this.variant && `rui-icon-text--${this.variant}`,
      ]
    },
  },
}
</script>
